export const consultantList = (state = {}, action) => {
  switch (action.type) {
    case "GET_CONSULATNT_LIST_REQUEST":
      return {
        loading: true,
        plan: null,
      };
    case "GET_CONSULATNT_LIST_SUCCESS":
      return {
        loading: false,
        plan: action.payload,
      };
    case "GET_CONSULATNT_LIST_FAILED":
      return {
        loading: false,
        error: action.payload,
      };


      
    default: {
      return state;
    }
  }
};
export const addConsultant = (state = {}, action) => {
  switch (action.type) {
    case "ADD_CONSULATNT_REQUEST":
      return {
        loading: true,
        isAdded: false,
      };
    case "ADD_CONSULATNT_SUCCESS":
      return {
        loading: false,
        isAdded: true,
        data: action.payload,
      };
    case "ADD_CONSULATNT_FAIL":
      return {
        loading: false,
        isAdded: false,
        error: action.payload,
      };
    case "CLEAR_ERRORS":
      return {
        ...state,
        error: null,
      };
    default:
      return state;
  }
};

export const editConsultant = (state = {}, action) => {
  switch (action.type) {
    case "EDIT_CONSULATNT_REQUEST":
      return {
        loading: true,
        isEdited: false,
      };
    case "EDIT_CONSULATNT_SUCCESS":
      return {
        loading: false,
        isEdited: true,
        data: action.payload,
      };
    case "EDIT_CONSULATNT_FAIL":
      return {
        loading: false,
        isEdited: false,
        error: action.payload,
      };
    case "CLEAR_ERRORS":
      return {
        ...state,
        error: null,
      };
    default:
      return state;
  }
};

export const enumsReducer = (state = {}, action) => {
  switch (action.type) {
    case "GET_ENUMS_REQUEST":
      return {
        loading: true,
        enumsData: null,
      };
    case "GET_ENUMS_SUCCESS":
      return {
        loading: false,
        enumsData: action.payload,
      };
    case "GET_ENUMS_FAILED":
      return {
        loading: false,
        getEnums: action.payload,
      };
    default:
      return state;
  }
};

export const viewConsultant = (state = {}, action) => {
  switch (action.type) {
    case "VIEW_CONSULATNT_REQUEST":
      return {
        loading: true,
        isEdited: false,
      };
    case "VIEW_CONSULATNT_SUCCESS":
      return {
        loading: false,
        isEdited: true,
        data: action.payload,
      };
    case "VIEW_CONSULATNT_FAIL":
      return {
        loading: false,
        isEdited: false,
        error: action.payload,
      };
    case "CLEAR_ERRORS":
      return {
        ...state,
        error: null,
      };
    default:
      return state;
  }
};

export const blockUnblockConsultant = (state = {}, action) => {
  switch (action.type) {
    case "BLOCK_UNBLOCK_REQUEST":
      return {
        loading: true,
        success: false,
      };
    case "BLOCK_UNBLOCK_SUCCESS":
      return {
        loading: false,
        success: true,
        data: action.payload,
      };
    case "BLOCK_UNBLOCK_FAILED":
      return {
        loading: false,
        success: false,
        error: action.payload,
      };
    case "CLEAR_ERRORS":
      return {
        ...state,
        error: null,
      };
    default:
      return state;
  }
};
export const acceptDeclineConsultant = (state = {}, action) => {
  switch (action.type) {
    case "ACCEPT_DECLINE_REQUEST":
      return {
        loading: true,
        success: false,
      };
    case "ACCEPT_DECLINE_SUCCESS":
      return {
        loading: false,
        success: true,
        data: action.payload,
      };
    case "ACCEPT_DECLINE_FAILED":
      return {
        loading: false,
        success: false,
        error: action.payload,
      };
    case "CLEAR_ERRORS":
      return {
        ...state,
        error: null,
      };
    default:
      return state;
  }
};
export const consultantProjectsReducer = (
  state = { projectData: [], loading: false },
  action
) => {
  switch (action.type) {
    case "GET_CONSULTANT_PROJECTS_REQUEST":
      return { loading: true, projectData: [] };
    case "GET_CONSULTANT_PROJECTS_SUCCESS":
      return {
        loading: false,
        projectData: action.payload?.data?.[0]?.projects || [],
      };
    case "GET_CONSULTANT_PROJECTS_FAIL":
      return { loading: false, error: action.payload, projectData: [] };
    default:
      return state;
  }
};
export const consultantProjectStatusReducer = (
  state = { loading: false, success: false, statusData: null, error: null },
  action
) => {
  switch (action.type) {
    case "ADD_STATUS_REQUEST":
      return {
        ...state,
        loading: true,
        success: false,
        error: null,
      };
    case "ADD_STATUS_SUCCESS":
      return {
        ...state,
        loading: false,
        success: true,
        statusData: action.payload,
      };
    case "ADD_STATUS_FAILED":
      return {
        ...state,
        loading: false,
        success: false,
        error: action.payload,
      };
    case "CLEAR_ERRORS":
      return {
        ...state,
        error: null,
      };
    default:
      return state;
  }
};

